/**
 * @desc 根据计划ID查询季度计划概览
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanQuarterOverviewResponse>>> {
  return defHttp.post({
    url: '/web/plan/quarter/queryPlanOverview',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanQuarterOverviewResponse>>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/queryPlanOverview',
    data,
  });
}
